import React, { useState } from 'react'
import {
  Card,
  Table,
  Button,
  Row,
  Col,
  message,
  Spin,
  Form,
  Avatar,
  Tag
} from 'antd'
import IntlMessages from '../../../util/IntlMessages'
import ds from '../../../Services/DataServices'
import Skeleton from 'react-loading-skeleton'
import { useHistory } from 'react-router-dom'
import { useDispatch, useStore, useSelector } from 'react-redux'
import {
  loadAddCashModalShow,
  loadIsRegistorLoading,
  loadCashListingLoading
} from '../../../appRedux/actions/Sell'
import {
  READ,
  CREATE,
  UPDATE,
  DELETE
} from '../../../constants/RightsAndPermissions'
import {
  loadIsSelectReg,
  setCommonConfigs
} from '../../../appRedux/actions/CommonData'
import {
  checkRightspermissions,
  formatDigits,
  getDecryptID,
  isEmptyObject
} from '../../../appRedux/actions/GlobalMethods'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import { GetIndexDBDataByTableName } from '../../../appRedux/actions/IndexDBActions'
import { INDEX_DB_NAME, INDEX_DB_TABLES } from '../../../constants/IndexDBData'
import moment from 'moment'
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  CloudSyncOutlined,
  CloudUploadOutlined,
  EyeOutlined,
  LoadingOutlined,
  RetweetOutlined
} from '@ant-design/icons'
import { SYNC_STATUSES } from '../../../constants/StoreSetting'
import InfoToPrint from '../../../components/InfoToPrint'
import { checkIsWeb, postDataToApp } from '../../../appRedux/actions/MobAppFn'
import { PostAppTypes } from '../../../constants/MobAppConstants'

const StatusList = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  const getDecimalPlaces = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  )
  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )

  const [isLoading, setIsLoading] = React.useState(true)
  const [getTableData, setTableData] = React.useState([])
  const [getCurrSymbol, setCurrSymbol] = useState('')
  const [getDataToPrint, setDataToPrint] = useState('')

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      if (!checkIsWeb().exist) {
        postDataToApp(PostAppTypes.PAGE_HEADER, 'offline.status.offsalestatus')
      }

      getIndexSales()
    }

    return () => (mounted = false)
  }, [])

  //for common data -> store currency
  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      const commonData = getReduxCommonSetting
      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {}
      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData
        setCurrSymbol(currencyData.currencySymbol)
      }
    }

    return () => (mounted = false)
  }, [getReduxCommonSetting])

  function getIndexSales () {
    const data = GetIndexDBDataByTableName(INDEX_DB_NAME, INDEX_DB_TABLES.SALES)
    data
      .then(e => {
        const saleExist = e.filter(
          q => q.isOffline == true && q.isCompleted == true
          // (q.isCompleted == true || q.isParked)
        )
        if (saleExist && saleExist.length > 0) {
          getOutletName(saleExist)
        } else setIsLoading(false)
      })
      .catch(e => {
        setIsLoading(false)
        console.log('STATUS_PAGE_INDEX_DB_ERROR -> getIndexSales -->', e)
      })
  }

  function getOutletName (saleExist) {
    const data = GetIndexDBDataByTableName(
      INDEX_DB_NAME,
      INDEX_DB_TABLES.STOREOUTLETS
    )
    data
      .then(e => {
        getRegName(saleExist, e && e.length > 0 ? e : false)
      })
      .catch(e => {
        setIsLoading(false)
        console.log('STATUS_PAGE_INDEX_DB_ERROR -> getOutletName -->', e)
      })
  }

  function getRegName (saleExist, outletsInfo) {
    const data = GetIndexDBDataByTableName(
      INDEX_DB_NAME,
      INDEX_DB_TABLES.STOREOUTLETS
    )
    data
      .then(e => {
        setIsLoading(false)
        const regsInfo = e && e.length > 0 ? e : false
        const prepData = saleExist.map(da => {
          let status = ''
          if (da.isSynced) status = SYNC_STATUSES.SYNCED
          else if (da.syncInProgress) status = SYNC_STATUSES.IN_PROGRESS
          else if (da.isSyncError) status = SYNC_STATUSES.ERROR
          else status = SYNC_STATUSES.PENDING
          return {
            key: da.indexKey,
            dateTime: da.datetime ? da.datetime : '',
            productCount: da.products ? da.products.length : 0,
            totalAmount: da.totalPrice ? da.totalPrice : 0,
            status: status,
            printData: da.printData ? da.printData : {},
            outletName:
              outletsInfo &&
              outletsInfo.filter(
                q => q.storeOutletID == getDecryptID(da.e_OutletID).length > 0
              )
                ? outletsInfo.filter(
                    q => q.storeOutletID == getDecryptID(da.e_OutletID)
                  )[0].outletName
                : '',
            registerName: ''
          }
        })
        setTableData(prepData)
      })
      .catch(e => {
        setIsLoading(false)
        console.log('STATUS_PAGE_INDEX_DB_ERROR -> getRegName -->', e)
      })
  }

  const columns = [
    {
      title: <IntlMessages id='offline.status.key' />,
      dataIndex: 'key',
      key: 'key',
      render: (text, record) => {
        return (
          <div>
            <Row style={{ marginLeft: 4 }}>
              <Col>
                <h3
                  style={{
                    fontSize: '14px'
                  }}
                >
                  {text}
                </h3>
              </Col>
            </Row>
          </div>
        )
      }
    },
    {
      title: <IntlMessages id='offline.status.createdon' />,
      dataIndex: 'dateTime',
      key: 'dateTime',
      render: (text, record) => {
        let date = ''
        let time = ''
        if (text) {
          const da = moment(text).format('MMMM Do YYYY, h:mm:ss a')
          if (da && da.includes(',')) {
            const daa = da.split(',')
            if (daa && daa.length > 0) {
              date = daa[0]
              time = daa.length > 1 ? daa[1] : ''
            }
          }
        }
        return (
          <div>
            <Row>
              <Col>
                <p
                  className='gx-link'
                  style={{ fontWeight: '500', marginBottom: '0px' }}
                >
                  {date}
                </p>
              </Col>
            </Row>

            <Row>
              <Col>
                <p style={{ fontWeight: '500' }}>{time}</p>
              </Col>
            </Row>
          </div>
        )
      }
    },
    {
      title: <IntlMessages id='offline.status.totalamount' />,
      dataIndex: 'totalAmount',
      key: 'totalAmount',
      render: (text, record) => {
        return (
          <Row style={{ marginLeft: 8 }}>
            <Col>
              <h3
                style={{
                  fontWeight: '500',
                  color: '#038fde',
                  fontSize: '14px'
                }}
              >
                {text
                  ? `${formatDigits(text, getDecimalPlaces)} ${
                      getCurrSymbol ? getCurrSymbol : 'EUR'
                    }`
                  : ''}
              </h3>
            </Col>
          </Row>
        )
      }
    },
    {
      title: <IntlMessages id='offline.status.status' />,
      dataIndex: 'status',
      key: 'status',
      render: (text, record) => {
        return (
          <div>
            <Row style={{ marginLeft: 34 }}>
              <Col>
                {text == SYNC_STATUSES.PENDING ? (
                  <p
                    className='status-off-symbols'
                    style={{ color: '#bdbd38', fontSize: '16px' }}
                  >
                    <CloudUploadOutlined />
                  </p>
                ) : text == SYNC_STATUSES.SYNCED ? (
                  <p
                    className='status-off-symbols'
                    style={{ color: '#41af4b', fontSize: '16px' }}
                  >
                    <CheckCircleOutlined />
                  </p>
                ) : text == SYNC_STATUSES.IN_PROGRESS ? (
                  <p
                    className='status-off-symbols'
                    style={{ color: '#05314a', fontSize: '16px' }}
                  >
                    <LoadingOutlined />
                  </p>
                ) : text == SYNC_STATUSES.ERROR ? (
                  <p
                    className='status-off-symbols'
                    style={{ color: '#ff4d4d', fontSize: '16px' }}
                  >
                    <CloseCircleOutlined />
                  </p>
                ) : (
                  <></>
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {text == SYNC_STATUSES.PENDING ? (
                  <Tag color='yellow' style={{ fontSize: '14px' }}>
                    Waiting to Sync
                  </Tag>
                ) : text == SYNC_STATUSES.SYNCED ? (
                  <Tag color='#87d068' style={{ fontSize: '14px' }}>
                    Successfully Synced
                  </Tag>
                ) : text == SYNC_STATUSES.IN_PROGRESS ? (
                  <Tag color='#2db7f5' style={{ fontSize: 'medium' }}>
                    Syncing in progress
                  </Tag>
                ) : text == SYNC_STATUSES.ERROR ? (
                  <Tag color='#f50' style={{ fontSize: '14px' }}>
                    Error in Syncing
                  </Tag>
                ) : (
                  <></>
                )}
              </Col>
            </Row>
          </div>
        )
      }
    },
    {
      title: <IntlMessages id='offline.status.viewsale' />,
      key: 'printData',
      dataIndex: 'printData',
      render: (text, record) => {
        return (
          <div>
            <Row style={{ marginLeft: 22 }}>
              <Col>
                <InfoToPrint
                  role='OfflineStatus'
                  data={text}
                  outletName={record.outletName}
                  registerName={record.registerName}
                  allowPrintNote={true}
                />
              </Col>
            </Row>
          </div>
        )
      }
    }
  ]

  return (
    <Spin
      tip={<IntlMessages id='sell.cashlisting.cashloading' />}
      spinning={isLoading}
      size='large'
    >
      <div className='Content-wrapper OfflineSalesStatus-pg'>
        {checkIsWeb().exist && (
          <h1 className=''>
            <IntlMessages id='offline.status.offsalestatus' />
          </h1>
        )}
        <Card className='gx-card' title=''>
          <Row>
            <Col className=''>
              <h4 className='mb-0 pl-3'>
                <IntlMessages id='offline.status.heading' />
                <span className='orange-color'><IntlMessages id='offline.status.subheading' /> </span>
              </h4>
            </Col>

          </Row>
        </Card>
        <div className='custom-product-table'>
          <Card className='noborder table-body'>
            {isLoading ? (
              <Skeleton count={7} height={35} />
            ) : (
              <Table
                className='gx-table-responsive'
                columns={columns}
                dataSource={getTableData}
                // loading={isLoadingTable}
                // pagination={getPagination}
                // onChange={handleTableChange}
              />
            )}
          </Card>
        </div>
      </div>
    </Spin>
  )
}

export default StatusList
